import { Avatar } from './src/Avatar.js';
import { Button } from './src/Button.js';
import { Paragraph } from './src/Paragraph.js';
import { Skeleton as Skeleton$1 } from './src/Skeleton.js';

const Skeleton = Skeleton$1;
Skeleton.Avatar = Avatar;
Skeleton.Button = Button;
Skeleton.Paragraph = Paragraph;

export { Skeleton };
//# sourceMappingURL=index.js.map
